import { Users, UserCheck, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function Participation({ onRegister }) {
  return (
    <section
      data-testid="ateliers-participation"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Participation
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Deux façons de participer
            </h2>
            <p className="mt-6 text-base text-[#5F6170]">
              Chaque place a sa valeur dans le travail collectif.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal>
            <article
              data-testid="ateliers-part-card-problematique"
              className="h-full p-10 bg-white rounded-3xl border border-[#DDD7E2] hover:border-[#C98FA3] hover:-translate-y-1 transition-all duration-300 shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-[#F3EEF4] flex items-center justify-center">
                <Users className="w-5 h-5 text-[#3A2E6E]" />
              </div>
              <h3 className="font-serif-display text-3xl mt-6 text-[#1E1E2A]">
                Avec votre problématique
              </h3>
              <p className="mt-5 text-base text-[#5F6170] leading-relaxed flex-grow">
                Vous venez avec une situation ou une question à explorer. Le travail
                permet de révéler des dynamiques invisibles dans un cadre accompagné.
              </p>
              <ul className="mt-6 space-y-2 text-sm text-[#5F6170]">
                <li className="flex items-start gap-2">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#C98FA3]" />
                  Une problématique posée à l'avance ou émergente
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#C98FA3]" />
                  Temps de travail dédié dans la journée
                </li>
              </ul>
              <button
                onClick={() => onRegister(null)}
                data-testid="ateliers-part-cta-problematique"
                className="mt-8 inline-flex items-center justify-between bg-[#2847B8] text-white hover:bg-[#3A2E6E] transition-all duration-300 rounded-full px-6 py-3 font-medium text-sm gap-2"
              >
                Réserver une place
                <ArrowUpRight className="w-4 h-4" />
              </button>
            </article>
          </Reveal>

          <Reveal delay={0.1}>
            <article
              data-testid="ateliers-part-card-representant"
              className="h-full p-10 bg-[#3A2E6E] text-white rounded-3xl border border-[#3A2E6E] hover:-translate-y-1 transition-all duration-300 shadow-[0_30px_60px_-20px_rgba(58,46,110,0.45)] flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center">
                <UserCheck className="w-5 h-5 text-[#E6D6DF]" />
              </div>
              <h3 className="font-serif-display text-3xl mt-6 text-white">
                Comme représentant
              </h3>
              <p className="mt-5 text-base text-white/80 leading-relaxed flex-grow">
                Vous prenez part au travail du groupe sans venir avec votre propre
                constellation. Cette place permet de vivre des prises de conscience
                profondes et de contribuer au processus collectif.
              </p>
              <ul className="mt-6 space-y-2 text-sm text-white/75">
                <li className="flex items-start gap-2">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#C98FA3]" />
                  Aucune problématique à apporter
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#C98FA3]" />
                  Une expérience souvent marquante
                </li>
              </ul>
              <button
                onClick={() => onRegister(null)}
                data-testid="ateliers-part-cta-representant"
                className="mt-8 inline-flex items-center justify-between bg-white text-[#3A2E6E] hover:bg-[#E6D6DF] transition-all duration-300 rounded-full px-6 py-3 font-medium text-sm gap-2"
              >
                Réserver une place
                <ArrowUpRight className="w-4 h-4" />
              </button>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
